import React, { Component } from 'react';
import { auth } from '../../firebase';
import API_ROOT from "../../../Constants/API_Root";
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Header, Input, Button, Icon, Message } from 'semantic-ui-react'
import {toggleModal} from "../../../Actions/ToggleModal";
import {toggleProBlock} from "../../../Actions/ToggleProBlock";
import {modifyFilePKProBlock} from "../../../Actions/ModifyFilePKProBlock";
import {modifyIntegrationAuth} from "../../../Actions/ModifyIntegrationAuth";
import isObjectEmpty from "../../../Constants/isObjectEmpty";
import { setCookie } from "../../../Constants/setCookie";

class LoginForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: this.initEmail(),
            password: '',
            error: null,
            loading: false,
            isAppSumo: this.initAppSumo()
        }

        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.login = this.login.bind(this);
        this.forgetPassword = this.forgetPassword.bind(this);
        this.dismissMessage = this.dismissMessage.bind(this);
    }

    initEmail = () => {
        const url = window.location.href;

        if (url.includes("&email=")){
            return url.substring(url.indexOf("&email=") + "&email=".length, url.length).trim()
        } else { return '' }
    }

    initAppSumo = () => { return (window.location.href).includes("?deal=appsumo") }

    handleKeyPress(e){
        if (e.charCode === 13){
            if (!(this.state.password.trim() === "" || this.state.email.trim() === "")){
                e.preventDefault()
                this.login(e)
            }
        }
    }

    handleInputChange(e){
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    login(e){
        e.preventDefault();

        this.setState({
            loading: true
        })

        const {
            email,
            password,
        } = this.state;

        const API = API_ROOT + "api/login/"

        const errorMessageObject = {
            message: <p>There was a problem logging in with our server. Refresh and try again! If the problem persists email us at support@apispreadsheets.com</p>
        };

        auth.doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState(() => ({
                    email:'',
                    password:'',
                    error: null,
                }));
                localStorage.setItem("email", email.toLowerCase().trim());

                fetch(API, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                    },
                    body: JSON.stringify({
                        email: email,
                        password: password,
                    })
                }).then((res) => {
                    if (res.status === 200){
                            res.json().then((data) => {
                                localStorage.setItem("token", data.token);

                                setCookie("apispreadsheetsEmail", email.toLowerCase().trim())
                                setCookie("apispreadsheetsToken", data.token)

                                if (this.state.isAppSumo){
                                    this.loginProfileLink.click()
                                } else {
                                    if (!('modal' in this.props)){
                                        this.filesLink.click()
                                    } else {
                                        this.props.toggleModal(null)
                                    }
                                }
                            }).catch((err) => { this.setState({ loading: false, error: errorMessageObject});
                        });
                    }
                    else{
                        this.setState({ loading: false, error: errorMessageObject })
                    }
                }).catch(err => this.setState({ loading: false, error: errorMessageObject }))
            }).catch(error => {
                this.setState({error: error, loading: false});
            });
    };

    forgetPassword(e){
        this.props.toggleModal(null);
        this.props.toggleModal("forgetPasswordModal")
    }

    dismissMessage(){
        this.setState({
            error: null
        })
    }

    render(){
        const {
            email,
            password,
            error,
        } = this.state;

        const isInvalid =
            password === '' ||
            email === '';

        let errorMessage = null;

        if (error !== null){
            if ("message" in error){
                errorMessage = <Message
                    onDismiss={this.dismissMessage}
                    content={error.message}
                    negative
                />
            }
        }

        let headerText = "Log In";
        let btnText = "Log In"
        let extraInfo = null;

        if ('modal' in this.props){
            if (this.props.modalInfo !== null) {
                if (typeof this.props.modalInfo === "object") {
                    if (!(isObjectEmpty(this.props.modalInfo))) {
                        if ("source" in this.props.modalInfo){
                            if (this.props.modalInfo.source === "cancelButton"){
                                headerText = "Re-authenticate"
                                btnText = "Re-authenticate Account"
                                extraInfo = <p style={{fontSize: '110%', color: 'red'}}>You can cancel your account after re-authentication</p>
                            }
                        }
                    }
                }
            }
        }

        return(
            <div className="segment-margin segment-raised" onKeyPress={this.handleKeyPress}>
                <a
                    style={{display: 'none'}}
                    ref={filesLink => this.filesLink = filesLink}
                    href={this.props.importer ? "/import" : "/api?menuItem=files"}
                >Download hidden</a>
                <a style={{display: 'none'}}  ref={loginProfileLink => this.loginProfileLink = loginProfileLink} href="/profile">Download hidden</a>
                <Header as='h1'>
                    {headerText}
                </Header>
                <br/>
                <Input icon="at"
                       id="loginEmail"
                       placeholder="Your Email"
                       iconPosition='left'
                       type="text" name="email" value={email}
                       onChange={this.handleInputChange}
                       fluid
                />
                <br/>
                <Input icon="lock"
                       id="loginPassword"
                       placeholder="Your Password"
                       iconPosition='left'
                       type="password" name="password" value={password}
                       onChange={this.handleInputChange}
                       fluid
                />
                <br/>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <Button loading={this.state.loading}
                            color={this.props.importer ? "orange" : "green"}
                            basic
                            disabled={isInvalid}
                            type="submit"
                            id="loginButton"
                            onKeyPress={this.handleKeyPress}
                            onClick={this.login} fluid>
                        <h4 className="thinHeading">{btnText} <Icon name="right arrow" /></h4>
                    </Button>
                </div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    {extraInfo}
                    <p className="linkStyle" onClick={this.forgetPassword}>Forgot password?</p>
                </div>
                {errorMessage}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    filePK: state.mainState.filePK,
    filePKProBlock: state.mainState.filePKProBlock,
    modalInfo: state.mainState.modalInfo
})

const mapActionsToProps = {
    navigateTo: push,
    toggleModal: toggleModal,
    toggleProBlock: toggleProBlock,
    modifyFilePKProBlock: modifyFilePKProBlock,
    modifyIntegrationAuth: modifyIntegrationAuth
}

export default connect(mapStateToProps, mapActionsToProps)(LoginForm);
